import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer, togglePopup } from 'apps/auth/actions/appAction';
import { deleteCard } from 'apps/auth/actions/cardsAction';
import { deleteDCAccount } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import { AUTH_CARD_DELETE } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FORM_NAME = 'deleteCardPopup';

const DeleteCardPopup = (props) => {
    const { removeCardButton, cardRemovedInfo, cardExpiredText } = usePageMessages();

    useEffect(() => {
        const selectedCard = props.selectedCard;
        const nameField = getField('name', selectedCard.alias, '', true, false, props.placeholder, 'text');
        const cardIdField = getField('id', selectedCard.id);
        const cardTypeField = getField('type', selectedCard.type);
        const force = getField('force', false);

        props.setNewForm(FORM_NAME, {
            [nameField.name]: nameField,
            [cardIdField.name]: cardIdField,
            [cardTypeField.name]: cardTypeField,
            [force.name]: force,
        });
    }, []);

    const onSubmitHandler = () => {
        let action;
        if (props.fromDcAccount) {
            action = props.deleteDCAccount(props.selectedCard.id, 'CARD');
        } else {
            action = props.customDeleteCard ? props.customDeleteCard(props.selectedCard.id) : props.deleteCard(props.selectedCard.id);
        }
        action.then(() => {
            if (props.popupRef?.current) {
                props.popupRef.current?.close();
                props.toggleModalWithTimer(true, cardRemovedInfo);
            } else {
                props.togglePopup(false, {}).then(() => {
                    props.toggleModalWithTimer(true, cardRemovedInfo);
                });
            }
        });
    };

    return (
        <Form action={AUTH_CARD_DELETE} formName={FORM_NAME} validateForm={false} onSubmitHandler={onSubmitHandler} beforeSubmit={(e) => e.stopPropagation()}>
            <SimplePopup popupRef={props.popupRef} text={resolveArguments(cardExpiredText, `${props.selectedCard.alias} ·· ${props.selectedCard.description}`)}>
                <PopupButton iconName="cross" type="submit" text={removeCardButton} />
            </SimplePopup>
        </Form>
    );
};

export default connect(null, {
    togglePopup,
    setNewForm,
    deleteCard,
    deleteDCAccount,
    toggleModalWithTimer,
})(DeleteCardPopup);
